import { connect } from 'react-redux'

import GroupPanel from './groupPanel'

const mapStateToProps = (state, ownProps) => {
  const {
    common: { currentSite },
    layout: { isSidebarOpen }
  } = state
  return { currentSite, isSidebarOpen }
}

const mapDispatchToProps = dispatch => {
  return {}
}

const GroupPanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupPanel)

export default GroupPanelContainer
